import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Page from '../../components/Page/Page';
import Loader from '../../components/Loader/Loader';
import axios from 'axios';
import { getApiLink } from '../../core/api';
import RoutesEnum from '../../core/enums/RoutesEnum';

const SnapDocumentDetails: React.FC<any> = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    useEffect(() => {
        axios
            .get(getApiLink('Article/GetId', { snapDocumentId: +id! }))
            .then((result) => {
                navigate(RoutesEnum.DocumentDetails.replace(':id', result.data), { replace: true });
            })
            .catch(() => {
                navigate(RoutesEnum.Home, { replace: true });
            });
    }, []);

    return (
        <Page title={''}>
            <Loader />
        </Page>
    );
};

export default SnapDocumentDetails;
